<template>
  <div class="page-container pt-3 pb-4 profile-page" v-if="$store.getters['auth/isLoggedIn']">
    <h1>Downloads</h1>
    <ul class="h5">
      <li v-for="download of downloads" :key="download.name">
        <a title="Export CSV" :href="download.csv"><i class="fa fa-file-excel-o my-2"></i></a>
        <a title="Export PDF" :href="download.pdf"><i class="fa fa-file-pdf-o mx-1"></i></a>
        Download {{ download.name }} Shiurim
      </li>
      <li class="list-unstyled mt-2"></li>
      <li>
        <a title="Export CSV" :href="`${this.basePath}/speakers.csv`"><i class="fa fa-file-excel-o my-2"></i></a>
        Download Speakers
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  i18nOptions: {
    namespaces: 'pages',
    keyPrefix: 'downloads',
  },
  data() {
    return {
      basePath: 'https://shas-media.s3.amazonaws.com/exports',
    }
  },
  computed: {
    downloads: function () {
      return ['Shas', 'Mishna', 'Torah'].map((item) => {
        return {
          name: item,
          csv: `${this.basePath}/${item.toLowerCase()}-shiurim.csv`,
          pdf: `${this.basePath}/${item.toLowerCase()}-shiurim.pdf`,
        };
      });
    }
  },
  mounted() {
    if (!this.$store.getters['auth/isLoggedIn']) {
      this.$router.push('/');
      this.$store.dispatch('auth/showModal');
    }
  },
};
</script>

<style></style>
